import Vue from "vue";
import store from '@/store'
import config from "@core/config/app.config";
import ServiceRepo from "@core/repositories/service.repo.js";
import { checkRolesAndRedirect } from '@core/config/utils'

export const appAccessHandler = function(to, from, next){ 
    const keycloak = Vue.prototype.$keycloak;
    const loggedIn = (keycloak && keycloak.authenticated) ? keycloak.authenticated : false;
    if(!loggedIn){next()}

    let accountId = to.params.accountId;
    ServiceRepo.defaults.baseURL = `${config.SERVICE_API_BASE_URL}/${accountId}`;

    let account = store.getters['auth/account.current'];
    let userAccess = store.getters['auth/userAccess']
    let product = window.location.pathname.split('/')[1];
    if(product != 'service' && product != 'commerce'){
        product = 'marketing'
    }

    const { path, meta, name, params } = to;
    if (path && !path.startsWith("/login")  && name !== "account_verify" ) {
      let fullPath = `${window.location.origin}/${product}${path}`;
      store.commit("ui/setPreviousRoute", { fullPath, path, meta, name, params });
    }  
    next()
}